<template>  

  <v-dialog id="dialog" v-model="dialog" max-width="850px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          text
          outlined
          class="primary--text mr-1"
          v-bind="attrs"  
          v-on="on"
          x-small
          >
        Proxy {{ hostPort }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="ml-3">Proxy local port to device</v-card-title>
      <v-card-text class="mt-2">
        <span class="ml-3">To connect locally to the port, run:</span>
        
        <v-container fluid class="mt-2 mb-2">
          <markup
              language="bash"
              :code="command()"
              :inline="false"
            ></markup>
        </v-container>

        <span class="ml-3">To listen on a different port (16000) locally:</span>
        
        <v-container fluid class="mt-2 mb-2">
          <markup
              language="bash"
              :code="command(16000)"
              :inline="false"
            ></markup>
        </v-container>

        <span class="ml-3">Once connected, use 'localhost:{{ hostPort }}' to connect, for example:</span>

        <v-container fluid>
          <v-row align="center">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    HTTP - <a :href="`http://localhost:${hostPort}`" target="_blank" rel="noopener">http://localhost:{{ hostPort }}</a>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    MySQL - jdbc:mariadb://localhost:{{ hostPort }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    MySQL - jdbc:mariadb://localhost:{{ hostPort }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Postgres - jdbc:postgresql://localhost:{{ hostPort }}/postgres
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>          
          </v-row>
        </v-container>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false" class="secondary--text"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
.addbtn {
  margin: 0px;
  top: auto;
  right: 20px;
  bottom: 20px;
  left: auto;
  position: fixed;
  z-index: 1;
}
</style>

<script>
import Markup from '../helpers/Markup';

export default {
  components: {
    Markup
  },
  props: {
    device: Object,
    port: String
  },
  data() {
    return {
      dialog: false
    }
  },

  computed: {
    hostPort() {
      // Port comes as mapping 'host:container' as in 8888:8888 for example.
      // we split it in half and then leave only host part
      const [host] = this.port.split(':');
      return host
    },
    project() {
      let project = this.$store.getters.getSelectedProject()
      if (project) {
        return project.name
      }
      return this.device.projectId
    }    
  },

  methods: {
    command(port) {
      if (!port) {
        port = this.hostPort
      }
      return `synpse --project ${this.project} \\\n device proxy ${this.device.name} ${port}:${this.hostPort}`
    },
    close() {
      // closing dialog
      // this.$emit('clicked', '')
      this.dialog = false
    }
  }
}
</script>
